import * as THREE from "three";

export default class BlackHole {
  constructor() {
    this.mesh = new THREE.Object3D();

    // Black Hole Sphere (Event Horizon)
    const sphereGeometry = new THREE.SphereGeometry(5, 32, 32);
    const sphereMaterial = new THREE.MeshPhongMaterial({
      color: 0x000000,
      shininess: 30, // Make it reflective
      specular: 0x222222, // Subtle specular highlight
      emissive: 0x111111, // Very subtle emissive to make it slightly visible
    });
    const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
    this.mesh.add(sphere);

    // Accretion Disk (Torus)
    const torusGeometry = new THREE.TorusGeometry(10, 2, 16, 100);
    const torusMaterial = new THREE.MeshPhongMaterial({
      color: 0xffa500,
      side: THREE.DoubleSide,
      emissive: 0x8b4513,
    });
    const torus = new THREE.Mesh(torusGeometry, torusMaterial);
    torus.rotation.x = Math.PI / 2;
    this.mesh.add(torus);

    // Add some glow to the disk (PointLight)
    const glowLight = new THREE.PointLight(0xffa500, 0.5, 30);
    this.mesh.add(glowLight);

    // Distort the Accretion Disk (Vertex Shader)
    torus.material.onBeforeCompile = (shader) => {
      shader.uniforms.time = { value: 0 };
      shader.vertexShader = `
        uniform float time;
        ${shader.vertexShader}
      `.replace(
        `#include <begin_vertex>`,
        `#include <begin_vertex>
        transformed.x += sin(transformed.y * 5.0 + time) * 1.0;
        transformed.y += cos(transformed.x * 5.0 + time) * 1.0;
        `
      );
      torus.material.userData.shader = shader;
    };

    this.update = (time) => {
      if (torus.material.userData.shader) {
        torus.material.userData.shader.uniforms.time.value = time * 0.5;
        torus.material.userData.shader.uniformsNeedUpdate = true;
      }
    };

    // Add a subtle light source to illuminate the black sphere
    const light = new THREE.PointLight(0x333333, 0.5, 20); // Very dim light
    this.mesh.add(light);
  }
}